type vlue = string | number | Array<string | number>;
export type Value = vlue | { notValue: vlue };

export enum SuperiorityProduct {
  YES = '是',
  NO = '否',
}

export enum SuperiorityProductValue {
  YES = 20,
  NO = 10,
}

export enum ProductType {
  DSD = '定时达',
  AXD = '安心达',
  PHD = '普惠达',
  JZLD = '精准零担',
  MINIMAX = 'MINI电商大件',
  MINIMIN = 'MINI电商小件',
}

export enum ProductTypeValue {
  '定时达' = '23',
  '精准零担' = '24',
  'MINI电商大件' = '95',
  '整车' = '220',
  '普惠达' = '270',
  '填仓' = '428',
  'MINI电商小件' = '524',
  '安心达' = '546',
}

export enum LengthOfTime {
  GRD = '隔日达',
  CRD = '次日达',
}

// 车辆提前到状态
export enum DurTimeStatus {
  /** 无法预计 */
  UNKNOWN = '无法预计',
  /** 提前 */
  PRE = '提前',
  /** 准时 */
  FIDUCIAL = '准时到达',
  /** 延误 */
  DELAY = '延误',
}
